export const CORRECT_ADDRESS_NOVELTIES = [
    { code: 'N-DIIN', idNovelty: 34, description: 'Dirección incompleta' },
    { code: 'N-DIER', idNovelty: 35, description: 'Dirección errada' },
    { code: 'N-CNL',  idNovelty: 30, description: 'Cliente no localizado' },
    { code: 'N-CNR',  idNovelty: 42, description: 'Cliente no recibe - rechazado' },
];

export const OFFER_AGAIN_NOVELTIES = [
    { code: 'N-CNR',  idNovelty: 42, description: 'Cliente no recibe - rechazado' },
    { code: 'N-CNL',  idNovelty: 30, description: 'Cliente no localizado' },
    { code: 'N-SINO', idNovelty: 47, description: 'Novedad no recibida' },
    { code: 'N-CNRS', idNovelty: 31, description: 'Cliente no recibe - sin dinero' },
];

export const RESCHEDULE_SOLUTIONS = {
    CORRECT_ADDRESS: { value: 2, label: 'Corregir Dirección', code: 'CORRECT_ADDRESS' },
    OFFER_AGAIN:     { value: 3, label: 'Volver a Ofrecer',   code: 'OFFER_AGAIN' },
};


export const getCoordinadoraResolutionOptions = (noveltyCode) => {
    const inCorrectAddress = CORRECT_ADDRESS_NOVELTIES.some(n => n.code === noveltyCode);
    const inOfferAgain     = OFFER_AGAIN_NOVELTIES.some(n => n.code === noveltyCode);

    if (inCorrectAddress && !inOfferAgain) {
        return [RESCHEDULE_SOLUTIONS.CORRECT_ADDRESS];
    }

    if (inOfferAgain && !inCorrectAddress) {
        return [RESCHEDULE_SOLUTIONS.OFFER_AGAIN];
    }

    return [
        RESCHEDULE_SOLUTIONS.OFFER_AGAIN,
    ];
};
